import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";
import { PAYROLL_PANE_FILL_CLASS_NAME } from "./payroll-grid-layout";
import {
  StAdjustmentsPreview,
  StAdjustmentsView,
  useStAdjustmentsSection,
} from "./st-adjustments";

// PushPay ServiceTitan payroll adjustments for the period on screen.
//
//
// State lives in `StAdjustmentsSectionProvider`, mounted above the page header
// so the push action and the technician pane can read it too. Run-change resets
// happen there rather than at a keyed boundary here — this tab is no longer the
// only reader, and remounting it would leave the other two holding stale state.
export const PayBreakdownAdjustmentsTab = () => {
  const { isPreview } = useStAdjustmentsSection();

  return (
    <Stack
      gap={0}
      align="stretch"
      className={cn("w-full", PAYROLL_PANE_FILL_CLASS_NAME)}
    >
      {isPreview ? <StAdjustmentsPreview /> : <StAdjustmentsView />}
    </Stack>
  );
};
